import { plainToClass, Expose, Transform } from 'class-transformer'

import { Appointment } from './Appointment'
import { ASN } from './ASN'
import { Audit } from './Audit'
import { BarcodedUnit } from './BarcodedUnit'
import { Base } from './Base'
import { Case } from './Case'
import { Client } from './Client'
import { Container } from './Container'
import { Damaged } from './Damaged'
import { DriverVisit } from './DriverVisit'
import { Facility } from './Facility'
import { FreightOrder } from './FreightOrder'
import { FreightShipment } from './FreightShipment'
import { Order } from './Order'
import { Pallet } from './Pallet'
import { ParcelOrder } from './ParcelOrder'
import { ParcelShipment } from './ParcelShipment'
import { Place } from './Place'
import { Product } from './Product'
import { Sku } from './Sku'
import { Shipment } from './Shipment'
import { Transload } from './Transload'
import { Truckload } from './Truckload'

const mapping: { [type: string]: typeof Base } = {
  [Appointment.type]: Appointment,
  [ASN.type]: ASN,
  [Audit.type]: Audit,
  [BarcodedUnit.type]: BarcodedUnit,
  [Case.type]: Case,
  [Client.type]: Client,
  [Container.type]: Container,
  [Damaged.type]: Damaged,
  [DriverVisit.type]: DriverVisit,
  [Facility.type]: Facility,
  [FreightOrder.type]: FreightOrder,
  [FreightShipment.type]: FreightShipment,
  [Order.type]: Order,
  [Pallet.type]: Pallet,
  [ParcelOrder.type]: ParcelOrder,
  [ParcelShipment.type]: ParcelShipment,
  [Place.type]: Place,
  [Product.type]: Product,
  [Sku.type]: Sku,
  [Shipment.type]: Shipment,
  [Transload.type]: Transload,
  [Truckload.type]: Truckload,
}

export class Generic extends Base {
  static type = 'generic'

  type = Generic.type

  get id() {
    return this.object.guid || this.object.slug
  }

  @Expose({ name: 'object_type' })
  objectType?: string

  @Transform((value, obj) => {
    const Model = mapping[obj.object_type as string]
    if (Model) {
      return plainToClass(Model, value)
    }
    return null
  })
  object?: any
}

export const makeGeneric = (obj: any) => {
  const generic = new Generic()
  generic.objectType = obj.type
  generic.object = obj
  return generic
}
